import { createFileRoute, Outlet } from '@tanstack/react-router'
import { requirePermission } from '../../../app/guards'

export const Route = createFileRoute('/_app/supplier-refunds')({
  staticData: { crumb: 'supplierRefunds' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'purchasing.read'),
  component: Outlet,
})
